import { render, staticRenderFns } from "./DealsList.vue?vue&type=template&id=22b6951b&scoped=true&"
import script from "./DealsList.vue?vue&type=script&lang=js&"
export * from "./DealsList.vue?vue&type=script&lang=js&"
import style0 from "./DealsList.vue?vue&type=style&index=0&id=22b6951b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6951b",
  null
  
)

export default component.exports